// src/components/nodes/TextNode.js
import { NodeBase } from './NodeBase';

export class TextNode extends NodeBase {
  constructor() {
    super('text', { 
      title: '文本标题',
      content: '这里是详细的文本内容，可以放置较多的文字说明...'
    });
  }

  renderContent(data, selected) {
    return (
      <div className={`text-content ${selected ? 'selected' : ''}`}>
        <div className="text-title">
          {data.title || '文本节点'}
        </div>
        <div className="text-body">
          {data.content || '请输入内容...'}
        </div>
      </div>
    );
  }

  getConfig() {
    return {
      type: this.type,
      label: '文本节点',
      icon: '📝',
      defaultData: this.defaultData
    };
  }
}